import { IWorkspaceDB } from "../interface/db";
import ILanguageDto from "../model/LanguageDto.if"
import ISiteDto from "../model/SiteDto.if"
import db from "../private/db";

function SiteSupportedLanguages(db: IWorkspaceDB, site?: ISiteDto): Promise<Array<ILanguageDto>> {
    return new Promise(async function(resolve, reject) {
        try {
            const siteLookup = site ??
                await (db.site().first() as Promise<ISiteDto>);

            const ssls = await db.siteSupportedLanguage().all();

            const languageIds = 
                ssls
                    .filter(ssl => ssl.siteId === siteLookup.id)
                    .map(ssl => ssl.languageId);

            const languages = await Promise.all(languageIds.map(id => db.language().get(id)));

            resolve(languages);
        } catch (error) {
            reject(error);
        }
    })
}

const exports = {
    SiteSupportedLanguages,
}

export default exports
